if (!customElements.get('alexia-sticky-gallery')) {
  customElements.define('alexia-sticky-gallery', class extends HTMLElement {
    connectedCallback() {
      if (!this.closest('product-info[id^="MainProduct-"]') || !('ResizeObserver' in window)) return;
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.update = () => {
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const height = this.getBoundingClientRect().height;
        this.toggleAttribute('data-sticky-fits', this.desktop.matches && height > 0 && height <= window.innerHeight - headerHeight - 32);
      };
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this);
      const header = document.querySelector('.section-header');
      if (header) this.resizeObserver.observe(header);
      this.headerObserver = new MutationObserver(this.update);
      this.headerObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
      window.addEventListener('resize', this.update, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      if (this.update) window.removeEventListener('resize', this.update);
    }
  });
}
